// extracted by mini-css-extract-plugin
export default {"dlFlag":"src-js-components-Flag---dlFlag---H+jRy","dlFlagEmpty":"src-js-components-Flag---dlFlagEmpty---FcFW4"};